// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App_v3'
import router from './router'
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Filters from '@/util/filter'
import { storageUtil, cleanCache} from '@/util/storage'
import STATIC_DATA from '@/util/static-data'
import Api from "@/api";
import Util from "@/util/util";
import APIS from '_libs/API';
import sentryPlugin from '@bxs/vue-plugin-sentry'
import {
    getObjVal,
    _isValue,
    localExpires,
    _toNumber,
    _getStr,
} from 'tools';
import {
    globalAddressJson,
    setGlobalAddressJson,
} from '_libs/TaskQueue';
import {
    trace,
    hasDataLength,
    globalControlConfig,
    control_insuranceConstructionProductData,
    $openWindow,
} from '_libs/util';
import {
    getConstructionAreaCode,
    getAreaCode,
} from '@/api/api';
import {
    showLoading,
    hideLoading,
} from '@/util/bridge';
import _cloneDeep from 'lodash.clonedeep'

import Fragment from 'vue-fragment'
import { getPremiumRateList } from './util/premiumRate';
import { processClauses } from './util/clause';
Vue.use(Fragment.Plugin)

Vue.use(sentryPlugin, {
    router, // router instance. Omit if not use VueRouter
    dsn: `https://17888c8058214022842df81f54a49884@sentryv2.winbaoxian.cn/16`, // from Sentry project setting
    environment: process.env.NODE_ENV === 'production' ? `production` : 'development' // typically 'development' or 'production'
})

store.watch((state, getters) => getters.agencyName, (agencyName, oldAgencyName) => {
    if (agencyName && !oldAgencyName) {
        document.title = agencyName
    }
})

Vue.config.devtools = true;
Vue.use(ElementUI)
Vue.use(Filters)
Vue.use(ele2Extend, APIS);
const urlParams = Util.getAllUrlParam()
Vue.mixin({

    data() {
        return {
            ANXIN: [501, 502, 503],
            GUZE: [504],
            addressJsonUrl: 'https://res.wyins.net/autoUpload/activity/address-data_772c64be9d65d7a.json',
            addressJsonUrl2: 'https://res.wyins.net/autoUpload/common/kjys-address2_061268b56e9d898.json',
            apiAddress: null,
        }
    },
    methods: {
        $openWindow,
        getAddressUrl(productId) {
          return new Promise((resolve, reject) => {
            productId = this.$route.params.productId || productId
            Api.getAreaCode({ productId })
              .then(res => {
                resolve(res)
              })
              .catch(e => {
                reject(e)
              })
          })
        },
        async global_getConstructionAreaCode(productId){
            const isUseConstructionAddressData = getObjVal(globalControlConfig, 'insuranceConstructionProductData.isUseConstructionAddressData');
            let res = null;
            if(!isUseConstructionAddressData) return res;
            let addressJsonFromLS = localExpires('ConstructionAreaCode');
            if(addressJsonFromLS && addressJsonFromLS.productId == productId){
                res = (addressJsonFromLS.data)
            }else{
                const data = await getConstructionAreaCode(productId);
                if(hasDataLength(data.province)){
                    localExpires('ConstructionAreaCode', {
                        data,
                        productId: productId,
                    }, 1);
                    res = data;
                };
            };
            if(res){
                if(!hasDataLength(res.city)) {
                    control_insuranceConstructionProductData({
                        onlyProvinceAddressData: true
                    });
                }
            }
            return res;
        },
        bridge_showLoading(params) {
            return showLoading(params);
        },
        bridge_hideLoading() {
            return hideLoading();
        },
        // JYYF-8149 修复地址配置错误但缓存一直存在的问题
        async global_getAddressJson(productId, callBack) {
            let res = null;
            productId = productId || this.$route.params.productId
            productId = _getStr(productId);
            if(globalAddressJson) {
                if(globalAddressJson.productId === productId && globalAddressJson.data) {
                    res = globalAddressJson.data;
                }else{
                    // globalAddressJson = null;
                    setGlobalAddressJson(null);
                    res = await this.global_getAddressJson(productId);
                };
            }else{
                const data = await getAreaCode(productId);
                if(hasDataLength(data.province)){
                    res = data;
                    setGlobalAddressJson({
                        data,
                        productId,
                    });
                };
            };
            callBack && callBack(res);
            return res;
        },
        getAddressJson(productId) {
          return new Promise(async (resolve, reject) => {
              try {
                const rep = await this.getAddressUrl(productId)
                if (rep.province && rep.city) {
                  this.apiAddress = rep
                  resolve(rep)
                } else {
                  reject(rep)
                }
              } catch (e) {
                this.$message.error(e && e.info || '地址信息获取失败！');
                reject(e)
              }

              // let addressJsonUrl = this.addressJsonUrl
              // if (location.href.indexOf('902') > -1) {
              //   addressJsonUrl = this.addressJsonUrl2
              // }
              // Api.getJsonFile(addressJsonUrl).then(rep => {
              //     this.apiAddress = rep
              //     resolve(rep)
              // }).catch(e => {
              //     this.$message.error(e && e.info || '地址信息获取失败！');
              //     reject(e)
              // })
          })

        },
        reSetRules(list, fromSearch) { // fromSearch-true(搜索的),false(列表的)
          let newRules = []
          if (this.rules && this.rules.length) {
            for (let rule of this.rules) {
              if (rule.profession) {
                let temp = {}, currRate = 1, tempErrorMsg = ''
                for (let key in rule) {
                  temp[key] = rule[key]
                }
                if (list && list.length > 1) { //多个职业
                  for (let profession of list) {
                    let tempProfession = temp.profession.find(item => item.profess.indexOf(Number(profession.val)) > -1)
                    let tempRate = tempProfession.rate
                    tempErrorMsg = tempProfession.errorMsg
                    if (tempRate < currRate) {
                      currRate = tempRate
                    }
                  }
                  if (currRate != 0) {
                    temp.rate = currRate
                    temp.errorMsg = tempErrorMsg
                  } else {
                    temp.rate = rule.rate
                  }
                } else {
                  let tempProfession = temp.profession.find(item => item.profess.indexOf(Number(list[0].val)) > -1)
                  if (tempProfession && tempProfession.rate) {
                    temp.rate = tempProfession.rate
                    temp.errorMsg = tempProfession.errorMsg
                  }
                }
                newRules.push(temp)
              } else {
                newRules.push(rule)
              }
            }
          }
          this.$store.commit('save', {key: 'rules', value: newRules || []})
        },
        storage(name, data) {
            return storageUtil(name, data)
        },
        cleanCache() {
            cleanCache()
        },
        getProfessions (groupPolicyJobInfo, personsInfo) {
            let professions = []
            try {
                for (let profession of groupPolicyJobInfo) {
                    let _personsInfo = personsInfo.filter((person) => {

                        if (person.occupationType == profession.jobType && person.occupationCode == profession.jobCode) {
                            person.insuredIdType = {
                                key: person.insuredIdType,
                                value: STATIC_DATA.ID_TYPES[person.insuredIdType]
                            }
                            person.insuredSex = {
                                key: person.insuredSex,
                                value: STATIC_DATA.GENDERS[person.insuredSex]
                            }
                            return true
                        }
                    })
                    profession.personsInfo = _personsInfo
                    profession.des = profession.jobDesc
                    profession.num = _personsInfo.length
                    profession.code = profession.jobCode
                    profession.val = profession.jobType.indexOf('1') + 1
                    profession.expend = false
                    professions.push(profession)
                }
                return professions
            } catch (e) {
                return []
            }
        },
        //根据第一个场所责任的选中状态判断其他场所责任是否可选
        changePlaceDutyStatusWithoutFirst (plans, isFirstPlaceDutySelected) {
            return plans.map((plan) => {
                if (isFirstPlaceDutySelected == 1) {

                    plan.disabled = false
                } else {
                    plan.disabled = true
                    plan.isSelected = 0
                }
                return plan
            })
        },
        //找出所有场所责任中不是第一个场所责任
        findOtherPlaceDutyWithoutFirst (planList = []) {
            return planList.filter((plan) => {
                let pattern = /^场所责任/
                return pattern.test(plan.clauseDesc) && !plan.firstPlaceDuty
            })
        },
        isAnxin(id) {
            if (this.ANXIN.filter(item => { return item == id}).length > 0) {
                return true
            } else {
                return false
            }
        },
        isGuze(id) {
            if (this.GUZE.filter(item => { return item == id}).length > 0) {
                return true
            } else {
                return false
            }
        },
        changeToList(data) {
            let list = [];
            for (let [key, value] of Object.entries(data)) {
                list.push({
                    key: key,
                    value: value
                })
            }
            return list
        },
        //获取产品条款列表
        getProductIssues (data, showNameFilter) {
            let list = [];
            for (let item of data) {
                let bool = showNameFilter ?
                    showNameFilter && item.showName === showNameFilter :
                    (item.showName === '保险条款' || item.showName === '特别告知')
                if (bool) {
                    if (item.type === 'parent') {
                        list = list.concat(item.value);
                    } else if (item.type === 'pdf') {
                        list.push(item);
                    } else if (/doc/.test(item.type)) {
                        list.push(item);
                    }
                }
            }
            return list
        },

        getDownloadJson(list) {
            let downloadJson = []
            function getFileList(data) {
                for (let item of data) {
                    if (item.type === 'parent' && item.platform !== 'mobile') {
                        getFileList(item.value)
                    } else if (item.platform !== 'mobile' && item.value) {
                        downloadJson.push(item)
                    }
                }
            }
            getFileList(list)
            return downloadJson
        },

        getTop(e) {
            if (e && !e.length) {
              return 0
            }
            if (Array.isArray(e)) {
                e = e[0]
            }
            let offset = e.offsetTop;
            if(e.offsetParent != null) {
                offset += this.getTop(e.offsetParent)
            }
            return offset;
        },

        formItemValidate(type) {
            const vm = this
            if (this.paramsRules && this.paramsRules.length > 0 && this.visible) {
                for (let rule of this.paramsRules) {
                    if (type && type !== rule.trigger) {
                        continue
                    }
                    let errorInfo = rule.fun(this.cValue, this.params, this.minDate, this.maxDate)

                    if(this.params && this.params.prop && this.params.prop === 'groupName' && errorInfo && errorInfo.includes('拒保')) {
                        Api.saveGroupWaylayRecord({
                            productId: vm.productId,
                            productName: vm.$store.getters.productName,
                            groupName: this.cValue
                        }).then(res => {}).catch(e => {})
                    }
                    if (errorInfo) {
                        this.setError(errorInfo)
                        return {errorInfo, offsetTop: this.getTop(this.$refs.formItem)}
                    }
                }
                this.clearError()
            }
        },
        initProductData(data, pageName) {
            const isRepeatPremiumRateWithFactors = getObjVal(this.globalControlConfig, 'insurePageConfig.isRepeatPremiumRateWithFactors');
            this.$store.commit('setBase', data.base)
            this.$store.commit('setFactorRate', data.factorRate || [])
            this.$store.commit('save', {key: 'front', value: data.front})
            // 保全相关
            this.$store.commit('save', {key: 'conservationType', value: data.conservationType})
            let durationList = JSON.parse(data.base.durationInfo)
            let duration = durationList[0]
            let frontControlInfo = JSON.parse(data.front.frontControlInfo)
            this.$store.commit('save', {key: 'frontControlInfo', value: frontControlInfo})
            this.appDescription = JSON.parse(data.front.appDescription)
            let description = JSON.parse(data.front.description || '{}')
            let materialInfo = JSON.parse(data.front.materialInfo || '[]')
            let downloadJson = materialInfo || []
            this.downloadJson = this.getProductIssues(downloadJson, '保险条款')


            // 新增逻辑判断 判断factorRateAll 数据返回的 内容中
            // 哪些的计划维度的 location === 1，哪些是保单维度的 location === 0
            // 兼容并排除 factorRate 里面的 accidentRate disabledRate
            // 兼容并排除 deductible 里面的 deductible deductibleRate
            // 以及factorRateAll 里面的 planCodes
            // start
            let canFindWithPlan = []
            let canFindWithOrder = []
            if(data && data.factorRateAll && data.factorRateAll.length) {
                let factorRateAll = data.factorRateAll
                let findOther = factorRateAll.filter(item => !['accidentRate', 'disabledRate', 'deductible', 'deductibleRate','planCodes'].includes(item.key))
                let findOther80124 = factorRateAll.filter(item => !['accidentRate', 'disabledRate', 'deductible', 'deductibleRate'].includes(item.key))
                if (data.productId == '80124') {
                    findOther = findOther80124
                }
                if(isRepeatPremiumRateWithFactors) {
                    findOther = findOther80124
                }
                if (findOther && findOther.length) {
                    findOther.map(item => item.selected = item.type == 2 ? {
                        ...item.factors[0],
                        rate: ''
                    } : item.factors[0])
                    let findWithPlan = findOther.filter(item => item.location === 1)
                    let findWithOrder = findOther.filter(item => item.location === 0)
                    if (findWithPlan && findWithPlan.length) {
                        canFindWithPlan = findWithPlan
                        this.$store.commit('withPlanList', findWithPlan)
                    }
                    if (findWithOrder && findWithOrder.length) {
                        canFindWithOrder = findWithOrder
                        this.$store.commit('withOrderList', findWithOrder)
                    }
                }
            } else{
                this.$store.commit('withPlanList', [])
                this.$store.commit('withOrderList', [])
            }
            // end


            this.$store.commit('save', {key: 'restrict', value: data.restrict})
            const premiumRate = getPremiumRateList({
                data,
                isRepeatPremiumRateWithFactors,
            });
            if (premiumRate.planCodeDefault) {
                this.$store.commit('save', {key: 'planCode', value: premiumRate.planCodeDefault})
            }
            if (premiumRate.premiumRateList) {
                this.$store.commit('save', {key: 'premiumRateList', value: premiumRate.premiumRateList})
            }
            // if (data.premiumRateList && data.premiumRateList.length) {
            //     // 设置为最小
            //     // this.$store.commit('save', {key: 'planCode', value: data.premiumRateList[0].planCode})
            //     // 设置为最大

            //     let planCodeDefault = data.premiumRateList[data.premiumRateList.length-1].planCode

            //     // 写死产品id 2001 计划 1
            //     if (data.productId == '2001' || data.factorRate && data.factorRate.planCodes && data.factorRate.planCodes.length) {
            //         planCodeDefault = '1'
            //     }
            //     // 写死产品id 205 计划 3
            //     if (data.productId == '205') {
            //         planCodeDefault = '3'
            //     }
            //     if (data.productId == '331') {
            //         planCodeDefault = '1'
            //     }
            //     if (data.productId == '332') {
            //         planCodeDefault = '4'
            //     }
            //     if (data.productId == '80124') {
            //         planCodeDefault = '1'
            //     }
            //     this.$store.commit('save', {key: 'planCode', value: planCodeDefault})
            //     data.premiumRateList.sort((a, b) => {
            //         return a.premiumRate > b.premiumRate
            //     })
            //     if(isRepeatPremiumRateWithFactors) {
            //         let premiumRateList80124Value = []
            //         data.premiumRateList.forEach(item => {
            //             if (!premiumRateList80124Value.includes(item.premiumRate)) {
            //                 premiumRateList80124Value.push(item.premiumRate)
            //             }
            //         })
            //         if (premiumRateList80124Value && premiumRateList80124Value.length) {
            //             premiumRateList80124Value.forEach((item, index) => {
            //                 premiumRateList80124.push({
            //                     planCode: index + 1,
            //                     premiumRate: item
            //                 })
            //             })
            //         }
            //     }
            //     // 写死产品id 205 费率档位区间取值
            //     if(isRepeatPremiumRateWithFactors) {
            //         this.$store.commit('save', {key: 'premiumRateList', value: premiumRateList80124})
            //     }else{
            //     if (data.productId == '205' && data.newBarPremiumRateList) {
            //         this.$store.commit('save', {key: 'premiumRateList', value: data.newBarPremiumRateList})
            //     } else if(data.productId == '80124') {
            //         this.$store.commit('save', {key: 'premiumRateList', value: premiumRateList80124})
            //     } else if (data.productId == '345') {
            //         this.$store.commit('save', {key: 'premiumRateList', value: [data.premiumRateList[0]]})
            //         this.$store.commit('save', {key: 'planCode', value: data.premiumRateList[0].planCode})
            //     } else {
            //         this.$store.commit('save', {key: 'premiumRateList', value: data.premiumRateList})
            //     }

            // }

            // }
            this.$store.commit('save', {key: 'description', value: description})
            this.$store.commit('save', {key: 'minRoleNum', value: JSON.parse(data.restrict.minRoleNumJson || '[]')})
            //  // 佣金率变化会影响保障计划中的选项，这里需要同步更新保障计划中的选项
            let cloneRules = _cloneDeep(frontControlInfo.dutyCheck || [])
            // console.log("🚀 ~ click_tag ~ cloneRules:", cloneRules, this.$store.state.writeStore.planCode)
            try {
                cloneRules.forEach(rule => {
                    if (rule.multiRates && this.$store.state.writeStore.planCode) {
                        rule.rates = rule.multiRates[this.$store.state.writeStore.planCode]
                    }
                })
            } catch (error) {
                console.error(error)
                cloneRules = _cloneDeep(frontControlInfo.dutyCheck || [])
            }
            this.$store.commit('save', {key: 'rules', value: cloneRules})
            this.$store.commit('save', {key: 'durationList', value: durationList})
            this.$store.commit('setClausePremium', data.clausePremium)
            this.$store.commit('setDuration', duration)
            this.$store.commit('setCareerType', frontControlInfo.careerType)
            this.$store.commit('setDiscountList', frontControlInfo.priceDiscount)
            this.$store.commit('setApplyQuantity', 1)
            this.$store.commit('save', {key: 'insureNameCheck', value: data.restrict && data.restrict.insureNameCheck ? parseInt(data.restrict.insureNameCheck) : 0})
            this.$store.commit('save', {key: 'clausesShow', value: data.clausesShow || []})

            // 7008
            if (data && data.base && data.base.productId === 7008) {
              this.$store.commit('save',{key: 'useAttribute', value: {key: '4', value: '营业'}})
              this.$store.commit('save',{key: 'vehicle', value: {key: '46', value: '货车'}})
              this.$store.commit('save',{key: 'vehicleDetail', value: {key: '37', value: '2吨以下货车'}})
            }
            if (!data.clausePremium) {
                return
            }
            //设置默认的免赔额免赔率
            let defaultDb = null
            let defaultDr = null
            let defaultDdr = null
            if (data.deductible && data.deductible.deductible) {
                data.deductible.deductible.forEach(item => {
                    item.disabled = false
                })
                this.$store.commit('setDbList', data.deductible.deductible)
                defaultDb = data.deductible.deductible[0].rate
                // this.$store.commit('setDb', defaultDb)
            }
            if (data.deductible && data.deductible.deductibleRate) {
                data.deductible.deductibleRate.forEach(item => {
                    item.disabled = false
                })
                this.$store.commit('setDrList', data.deductible.deductibleRate)
                defaultDr = data.deductible.deductibleRate[0].rate
                // this.$store.commit('setDr', defaultDr)
            }

            if (data.deductible && data.deductible.disabledRate) {
                data.deductible.disabledRate.forEach(item => {
                    item.disabled = false
                })
                this.$store.commit('setDDrList', data.deductible.disabledRate)
                defaultDdr = data.deductible.disabledRate[0].rate
                // this.$store.commit('setDr', defaultDr)
            }

            // 筛选出 "保额只能选择不投保，或者保额等于主险" 的规则
            let dutyList = this.rules.filter( duty => {
                if (duty.static && !duty.levelVal) {
                    return true
                } else {
                    return false
                }
            })
            let staticPlanDuty = this.rules.filter( duty => {
                if (duty.staticPlan && duty.dutyMax) {
                    return true
                } else {
                    return false
                }
            })[0]
            let mergeDuty = this.rules.filter( duty => {
                if (duty.merge) {
                    return true
                } else {
                    return false
                }
            })
            const otherList = this.rules.filter( duty => {
                if (duty.isOther) {
                    return true
                } else {
                    return false
                }
            })

            let firstPlaceDuty = false //是不是第一个场所责任（下面循环的时候会用到）

            let key1, key2, key3
            // 计划不需要匹配职业
            if (frontControlInfo.careerType && frontControlInfo.careerType.length == 1 && frontControlInfo.careerType[0] === '0') {
              key1 = 'D_' + duration.duration + duration.durationUnit
              key2 = key1
              key3 = key1
            } else if (frontControlInfo.careerType && frontControlInfo.careerType.length == 1) {
              key1 = 'D_' + duration.duration + duration.durationUnit + '_P_' + frontControlInfo.careerType[0]
              key2 = key1
              key3 = key1
            } else {
              key1 = 'D_' + duration.duration + duration.durationUnit + '_P_' + frontControlInfo.careerType[0]
              key2 = key1
              key3 = key1
            }

            if (this.$store.state.dbList && this.$store.state.dbList.length > 0) {
                key2 += '_db_' + defaultDb
            }
            if (this.$store.state.drList && this.$store.state.drList.length > 0) {
                key2 += '_dr_' + defaultDr
            }
            if (this.$store.state.drList && this.$store.state.drList.length > 0) {
                key3 += '_ddr_' + defaultDdr
            }

            let list1 = data.clausePremium[key1]
            let list2 = data.clausePremium[key2]
            let list3 = data.clausePremium[key3]

            if (list2 && list2.length > 0) {
                list1 = list1.concat(list2)
            }
            if (list3 && list3.length > 0) {
                list1 = list1.concat(list3)
            }
            // 初始化投保计划
            for (let item of data.clauses) {

                item.openContent = false
                let insuredBeans = this.productMsg.clauseInsuredBeans.filter(m => {
                    return m.clauseCode == item.clauseCode
                })[0]

                let clausePremiumItem = list1.filter(m => {
                    return m.clauseCode == item.clauseCode
                })[0]

                if (frontControlInfo.isAX) {
                    item.subDutys = []
                    for (let subDuty of item.introduce.split('^')) {
                        item.subDutys.push({
                            openContent: false,
                            introduce: subDuty
                        })
                    }
                    let pattern = /^场所责任/g
                    if (pattern.test(item.clauseName)) {
                        if (!firstPlaceDuty) {
                            firstPlaceDuty = true
                            item.firstPlaceDuty = true
                            item.status = 'isSelectable'
                        } else {
                            item.status = 'isDisabled'
                        }
                    } else {
                        item.status = 'isSelectable'
                    }

                    if (insuredBeans) {
                        let list = []
                        for (let insured of insuredBeans.insuredSet) {
                            let nameStr = insured + insuredBeans.insuredUnit
                            list.push({
                                insured,
                                nameStr
                            })
                        }
                        item.insuredList = list
                        item.selected = list[0]
                    }
                } else {
                    if (insuredBeans) {
                        let isMinDuty = dutyList.filter(duty => {
                            return item.clauseCode === duty.dutyMin
                        })[0]
                        const otherObj = otherList && otherList.find(
                            _ => _.dutyMin === item.clauseCode
                        ) || {};

                        let list = []

                        for (let insured of insuredBeans.insuredSet) {
                            let nameStr = insured + insuredBeans.insuredUnit
                            const other_insured = getObjVal(otherObj,`insuredSet.${insured}`);
                            const other_insured_str = getObjVal(otherObj,`insuredSetStr.${insured}`);
                            if(_isValue(other_insured)) {
                                nameStr = other_insured + insuredBeans.insuredUnit;
                            }
                            if(_isValue(other_insured_str)){
                                nameStr = other_insured_str;
                            }
                            if (isMinDuty && isMinDuty.rate == 1 && !['901','902','103'].includes(String(this.productId)) && !otherObj.noStaticStrRate1) {
                                let productId = this.productId || data.productId
                                if (insured == 0) {
                                    nameStr = ['880','990'].includes(String(productId))  ? '不投保' : '不购买'
                                } else {
                                    nameStr = ['880','990'].includes(String(productId))  ? '投保' :'同主险'
                                }
                            }
                            if (['50512'].includes(String(this.productId)) && isMinDuty && isMinDuty.rate) {
                              if (insured == 0) {
                                  nameStr = '不购买'
                              } else {
                                  nameStr = '主险保额的50%'
                              }
                            }
                            if (insuredBeans.insuredSet.length == 1 && insuredBeans.insuredSet[0] == 0) {
                                nameStr = '同主险'
                            }
                            if (insuredBeans.clauseCode == 'URBP024') {
                              nameStr = '-'
                            }
                            if(otherObj.insuredText0){
                                if (insured == 0) {
                                    nameStr = otherObj.insuredText0
                                }else if(otherObj.staticName){
                                    nameStr = otherObj.staticName
                                }
                            }
                            // 2001 该责任只能选择投保或者不投保
                            if (isMinDuty && isMinDuty.dutyMinDefault) {
                              if (insured == 0) {
                                  nameStr = '不购买'
                              } else {
                                  nameStr = '购买'
                              }
                            }else if(isMinDuty && isMinDuty.nameStrDefault){
                              const nameStrDefault = isMinDuty.nameStrDefault;
                              if (insured == 0) {
                                  nameStr = nameStrDefault[0]
                              } else {
                                  nameStr = nameStrDefault[1]
                              }
                            }
                            let staticName = isMinDuty && isMinDuty.nameStr || ""
                            if(staticName) nameStr = staticName;
                            if(otherObj.staticName) {
                                staticName = otherObj.staticName;
                            }

                            if (['80132'].includes(String(this.productId)) && insuredBeans.clauseCode === "GP801321") {
                                const nameStrObj = {1: '温馨版', 2: '温馨加强版', 3: '财神版', 4: '财神加强版', 5: '财神豪华版'}
                                nameStr = nameStrObj[insured]
                            }
                            const currentDutyRule = this.rules.find(rule => rule.dutyMin == item.clauseCode);
                            // 80212特殊处理，扩展、不扩展跟随保障方案planCode的值取值不同
                            if (currentDutyRule && currentDutyRule.planCodeRelated) {
                                // console.log('🃏 80212', this.$store.state.planCode);
                                nameStr = insured == 0 ? currentDutyRule.nameStrDefault[0] : currentDutyRule.nameStrDefault[1]
                            }

                            list.push({
                                insured,
                                nameStr,
                                staticName,
                            })
                        }
                        item.insuredList = list
                        item.unit = insuredBeans.insuredUnit

                        if (clausePremiumItem) {
                            let firstPremium = clausePremiumItem.groupProductPremiumList[0]
                            let supportItem = list.filter(p => {
                                return p.insured == firstPremium.insured
                            })[0]
                            if (supportItem) {
                                item.selected = supportItem
                            } else {
                                item.selected = list[0]
                            }
                        } else {
                            item.selected = list[0]
                        }
                    }
                }
            }

            if (staticPlanDuty) {
                let firstStaticPlan = staticPlanDuty.data[0]
                for (let item of data.clauses) {
                    let staticPlanItem = firstStaticPlan.filter(p => {
                        return p.duty == item.clauseCode
                    })[0]
                    if (staticPlanItem) {
                        let staticInsured = item.insuredList.filter(i => {
                            return i.insured == staticPlanItem.insured
                        })[0]
                        if (staticInsured) {
                            item.selected = staticInsured
                        }
                    }
                }
            } else if (mergeDuty.length > 0) {
                for (let md of mergeDuty) {
                    let newClause = {
                        clauseName: md.data.clauseName,
                        insuredList: [],
                        introduce: '',
                        selected: null,
                        merge: true,
                    }
                    for (let i = 0; i < md.data.dutyList.length; i++) {
                        let clause = data.clauses.filter(item => {
                            return item.clauseCode == md.data.dutyList[i]
                        })[0]
                        if (!clause) {
                            console.error('找不到配置的责任>', md.data.dutyList[i])
                            continue
                        }
                        clause.hidden = true
                        newClause.introduce += clause.introduce + '</br>'
                    }

                    for (let combination of md.data.combination) {
                        let insuredItem = {
                            insured: '',
                            nameStr: '',
                        }
                        for (let i = 0; i < combination.length; i++) {
                            let insured = combination[i]
                            let clause = data.clauses.filter(item => {
                                return item.clauseCode == md.data.dutyList[i]
                            })[0]
                            insuredItem.insured += (insuredItem.insured ? '&': '') + insured
                            insuredItem.nameStr += (insuredItem.nameStr ? '、': '') + md.data.nameList[i] + insured + clause.unit
                        }
                        newClause.insuredList.push(insuredItem)
                    }
                    newClause.selected = newClause.insuredList[0]

                    let mergedList = []
                    for (let item of md.data.dutyList) {
                        mergedList.push(data.clauses.filter(c => {
                            return c.clauseCode == item
                        })[0])
                    }

                    let mergedInsuredList = newClause.selected.insured.split('&')
                    for (let i = 0; i < mergedList.length; i++) {
                        for (let item of mergedList[i].insuredList) {
                            if (item.insured == mergedInsuredList[i]) {
                                mergedList[i].selected = item
                            }
                        }
                    }

                    data.clauses.push(newClause)
                }
            }

            let newList = []
            if(isRepeatPremiumRateWithFactors) {
                if(data.factorRate && data.factorRate.planCodes && !isRepeatPremiumRateWithFactors) {
                    data.factorRate.planCodes.forEach(item => {
                        newList.push({
                            "insured": item.rate,
                            "nameStr": item.desc,
                            "staticName": "",
                            "disabled": false
                        })
                    })
                }
                this.$store.commit('setDefaultPlan', {
                    planList: data.clauses,
                    deductible: defaultDb,
                    deductibleRate: defaultDr,
                    disabledRate: defaultDdr,
                    planCodes: [],
                    planCodesValue: newList && newList [0] || {},
                    withPlanList: canFindWithPlan,
                    withOrderList: canFindWithOrder,
                })
            }else{
            if(data.factorRate && data.factorRate.planCodes && data.productId !== 80124) {
                data.factorRate.planCodes.forEach(item => {
                    newList.push({
                        "insured": item.rate,
                        "nameStr": item.desc,
                        "staticName": "",
                        "disabled": false
                    })
                })
            }


            this.$store.commit('setDefaultPlan', {
                planList: data.clauses,
                deductible: defaultDb,
                deductibleRate: defaultDr,
                disabledRate: defaultDdr,
                planCodes: data.productId !== 80124 ? (data.factorRate && data.factorRate.planCodes || []) : [],
                planCodesValue: newList && newList [0] || {},
                withPlanList: canFindWithPlan,
                withOrderList: canFindWithOrder,
            })

        }

            this.$store.commit('addNewScheme', pageName)
        },
        initProductDataNew(data) {
            this.$store.commit('setBase', data.base);
            this.$store.commit('setAllClauseList', data.allClauseList);
            this.$store.commit('setFactorRate', data.factorRate || []);
            this.$store.commit('save', { key: 'front', value: data.front });
            let durationList = JSON.parse(data.base.durationInfo);
            let duration = durationList[0];
            let frontControlInfo = JSON.parse(data.front.frontControlInfo);
            this.$store.commit('save', { key: 'frontControlInfo', value: frontControlInfo });
            this.appDescription = JSON.parse(data.front.appDescription);
            let description = JSON.parse(data.front.description || '{}');
            let materialInfo = JSON.parse(data.front.materialInfo || '[]');
            let downloadJson = materialInfo || [];
            this.downloadJson = this.getProductIssues(downloadJson, '保险条款');

            this.$store.commit('save', { key: 'restrict', value: data.restrict });
            this.$store.commit('setAgeLimit', data.restrict);
            if (data.premiumRateList && data.premiumRateList.length) {
              // 设置为最大
              let planCodeDefault = data.premiumRateList[data.premiumRateList.length - 1].planCode;
      
              this.$store.commit('save', { key: 'planCode', value: planCodeDefault });
              data.premiumRateList.sort((a, b) => {
                return a.premiumRate > b.premiumRate;
              });
              this.$store.commit('save', { key: 'premiumRateList', value: data.premiumRateList });
            } else {
              this.$store.commit('save', { key: 'planCode', value: '0' });
            }
            this.$store.commit('save', { key: 'description', value: description });
            this.$store.commit('save', {
              key: 'minRoleNum',
              value: JSON.parse(data.restrict.minRoleNumJson || '[]'),
            });
            this.$store.commit('save', { key: 'rules', value: frontControlInfo.dutyCheck || [] });
            this.$store.commit('save', { key: 'durationList', value: durationList });
            this.$store.commit('setClausePremium', data.clausePremium);
            this.$store.commit('setDuration', duration);
            this.$store.commit('setCareerType', frontControlInfo.careerType);
            this.$store.commit('setDiscountList', frontControlInfo.priceDiscount);
            this.$store.commit('setApplyQuantity', 1);
            this.$store.commit('save', {
              key: 'insureNameCheck',
              value:
                data.restrict && data.restrict.insureNameCheck
                  ? parseInt(data.restrict.insureNameCheck)
                  : 0,
            });
      
            // 0-订单维度责任 1-计划维度责任
            const planClauseList = processClauses(data.allClauseList, 1);
            const orderClauseList = processClauses(data.allClauseList, 0);
            const defalutPlan = {
              // 新模板不同用 planlist，使用 allClauseList 根据 type 区分计划维度和订单维度的责任
              planList: [],
              planClauseList,
              careerTypeList: data.careerTypeList,
            };
            this.$store.commit('setDefaultPlan', defalutPlan);
            // console.log('this.schemes', this.$store.state.schemes);
            this.$store.commit('save', {
              key: 'orderClauseList',
              value: orderClauseList || [],
            });
            this.$store.commit('addNewSchemeNew');
        },
        nextTick_setTimeout(Fn, time = 300){
            return this.$nextTick(() => setTimeout(Fn, time));
        },
    }
})

const whiteList = ['/index', '/information']
router.beforeEach((to, from, next) => {
    store.commit('SET_HEADER', to.path)
    store.commit('SET_TO_PATH', to.path)
    if (!store.getters.loginStatus && !(urlParams.uuid && urlParams.source === 'app')) { // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetInfo').then(res => { // 拉取user_info
            // const hostName = window.location.hostname
            // const protocol = window.location.protocol
            // const httpsStr = `${protocol}//${hostName}`
            // if (store.getters.appId && store.getters.openId) {
            //     if (httpsStr === process.env.BASE_API || httpsStr === 'https://dev.wyins.net.cn') {
            //         store.commit('SET_GO_PAGE', to.fullPath || to.path)
            //         store.commit('SET_LOGIN_MODAL', true)
            //     } else{
            //         next()
            //     }
            // } else {
            //     if (httpsStr === process.env.TX_HOST) {
            //         store.commit('SET_GO_PAGE', to.fullPath || to.path)
            //         store.commit('SET_LOGIN_MODAL', true)
            //     }
            //     else{
            //         next()
            //     }
            // }
            next()
        }).catch(error => {
            if ((error.resCode === '001011' || parseInt(error.code) == 401) && !whiteList.filter(item => { return item == to.path}).length) {
                store.commit('SET_GO_PAGE', to.fullPath || to.path)
                store.commit('SET_LOGIN_MODAL', true)
            } else {
                next()
            }

        })
    } else {
        next()
    }
});

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js